import { call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'support/api/client';

export const types = {
  // Dashboard
  FETCH_DASHBOARD: 'GLOBAL/FETCH_DASHBOARD',
  FETCH_DASHBOARD_SUCCESS: 'GLOBAL/FETCH_DASHBOARD_SUCCESS',
  FETCH_DASHBOARD_FAILURE: 'GLOBAL/FETCH_DASHBOARD_FAILURE',

  FETCH_OVERVIEW: 'GLOBAL/FETCH_OVERVIEW',
  FETCH_OVERVIEW_SUCCESS: 'GLOBAL/FETCH_OVERVIEW_SUCCESS',
  FETCH_OVERVIEW_FAILURE: 'GLOBAL/FETCH_OVERVIEW_FAILURE',
  SET_OVERVIEW_PERIOD: 'GLOBAL/SET_OVERVIEW_PERIOD',

  // Accounts
  FETCH_ACCOUNTS: 'GLOBAL/FETCH_ACCOUNTS',
  FETCH_ACCOUNTS_SUCCESS: 'GLOBAL/FETCH_ACCOUNTS_SUCCESS',
  FETCH_ACCOUNTS_FAILURE: 'GLOBAL/FETCH_ACCOUNTS_FAILURE',
  FETCH_ACCOUNT_DETAIL: 'GLOBAL/FETCH_ACCOUNT_DETAIL',
  FETCH_ACCOUNT_DETAIL_SUCCESS: 'GLOBAL/FETCH_ACCOUNT_DETAIL_SUCCESS',
  FETCH_ACCOUNT_DETAIL_FAILURE: 'GLOBAL/FETCH_ACCOUNT_DETAIL_FAILURE',
  TOGGLE_ACCOUNT: 'GLOBAL/TOGGLE_ACCOUNT',
  TOGGLE_ACCOUNT_SUCCESS: 'GLOBAL/TOGGLE_ACCOUNT_SUCCESS',
  TOGGLE_ACCOUNT_FAILURE: 'GLOBAL/TOGGLE_ACCOUNT_FAILURE',
  TOGGLE_PROMPT_LOGGING: 'GLOBAL/TOGGLE_PROMPT_LOGGING',
  TOGGLE_PROMPT_LOGGING_SUCCESS: 'GLOBAL/TOGGLE_PROMPT_LOGGING_SUCCESS',
  TOGGLE_PROMPT_LOGGING_FAILURE: 'GLOBAL/TOGGLE_PROMPT_LOGGING_FAILURE',
  UPDATE_SCAN_CONFIG: 'GLOBAL/UPDATE_SCAN_CONFIG',
  UPDATE_SCAN_CONFIG_SUCCESS: 'GLOBAL/UPDATE_SCAN_CONFIG_SUCCESS',
  UPDATE_SCAN_CONFIG_FAILURE: 'GLOBAL/UPDATE_SCAN_CONFIG_FAILURE',
  ONBOARD_ACCOUNT: 'GLOBAL/ONBOARD_ACCOUNT',
  ONBOARD_ACCOUNT_SUCCESS: 'GLOBAL/ONBOARD_ACCOUNT_SUCCESS',
  ONBOARD_ACCOUNT_FAILURE: 'GLOBAL/ONBOARD_ACCOUNT_FAILURE',
  CLEAR_ONBOARD_STATE: 'GLOBAL/CLEAR_ONBOARD_STATE',
  CLOSE_ACCOUNT_DETAIL: 'GLOBAL/CLOSE_ACCOUNT_DETAIL',

  // Users
  FETCH_USERS: 'GLOBAL/FETCH_USERS',
  FETCH_USERS_SUCCESS: 'GLOBAL/FETCH_USERS_SUCCESS',
  FETCH_USERS_FAILURE: 'GLOBAL/FETCH_USERS_FAILURE',
  FETCH_USER_DETAIL: 'GLOBAL/FETCH_USER_DETAIL',
  FETCH_USER_DETAIL_SUCCESS: 'GLOBAL/FETCH_USER_DETAIL_SUCCESS',
  FETCH_USER_DETAIL_FAILURE: 'GLOBAL/FETCH_USER_DETAIL_FAILURE',
  CLOSE_USER_DETAIL: 'GLOBAL/CLOSE_USER_DETAIL',

  // Audit
  FETCH_AUDIT: 'GLOBAL/FETCH_AUDIT',
  FETCH_AUDIT_SUCCESS: 'GLOBAL/FETCH_AUDIT_SUCCESS',
  FETCH_AUDIT_FAILURE: 'GLOBAL/FETCH_AUDIT_FAILURE',

  // Backend definitions
  FETCH_BACKEND_DEFINITIONS: 'GLOBAL/FETCH_BACKEND_DEFINITIONS',
  FETCH_BACKEND_DEFINITIONS_SUCCESS: 'GLOBAL/FETCH_BACKEND_DEFINITIONS_SUCCESS',
  FETCH_BACKEND_DEFINITIONS_FAILURE: 'GLOBAL/FETCH_BACKEND_DEFINITIONS_FAILURE',
  CREATE_BACKEND_DEFINITION: 'GLOBAL/CREATE_BACKEND_DEFINITION',
  CREATE_BACKEND_DEFINITION_SUCCESS: 'GLOBAL/CREATE_BACKEND_DEFINITION_SUCCESS',
  CREATE_BACKEND_DEFINITION_FAILURE: 'GLOBAL/CREATE_BACKEND_DEFINITION_FAILURE',
  UPDATE_BACKEND_DEFINITION: 'GLOBAL/UPDATE_BACKEND_DEFINITION',
  UPDATE_BACKEND_DEFINITION_SUCCESS: 'GLOBAL/UPDATE_BACKEND_DEFINITION_SUCCESS',
  UPDATE_BACKEND_DEFINITION_FAILURE: 'GLOBAL/UPDATE_BACKEND_DEFINITION_FAILURE',
  DELETE_BACKEND_DEFINITION: 'GLOBAL/DELETE_BACKEND_DEFINITION',
  DELETE_BACKEND_DEFINITION_SUCCESS: 'GLOBAL/DELETE_BACKEND_DEFINITION_SUCCESS',
  DELETE_BACKEND_DEFINITION_FAILURE: 'GLOBAL/DELETE_BACKEND_DEFINITION_FAILURE',

  // Account backend overrides
  FETCH_ACCOUNT_BACKENDS: 'GLOBAL/FETCH_ACCOUNT_BACKENDS',
  FETCH_ACCOUNT_BACKENDS_SUCCESS: 'GLOBAL/FETCH_ACCOUNT_BACKENDS_SUCCESS',
  FETCH_ACCOUNT_BACKENDS_FAILURE: 'GLOBAL/FETCH_ACCOUNT_BACKENDS_FAILURE',
  CREATE_ACCOUNT_BACKEND: 'GLOBAL/CREATE_ACCOUNT_BACKEND',
  CREATE_ACCOUNT_BACKEND_SUCCESS: 'GLOBAL/CREATE_ACCOUNT_BACKEND_SUCCESS',
  CREATE_ACCOUNT_BACKEND_FAILURE: 'GLOBAL/CREATE_ACCOUNT_BACKEND_FAILURE',
  UPDATE_ACCOUNT_BACKEND: 'GLOBAL/UPDATE_ACCOUNT_BACKEND',
  UPDATE_ACCOUNT_BACKEND_SUCCESS: 'GLOBAL/UPDATE_ACCOUNT_BACKEND_SUCCESS',
  UPDATE_ACCOUNT_BACKEND_FAILURE: 'GLOBAL/UPDATE_ACCOUNT_BACKEND_FAILURE',
  DELETE_ACCOUNT_BACKEND: 'GLOBAL/DELETE_ACCOUNT_BACKEND',
  DELETE_ACCOUNT_BACKEND_SUCCESS: 'GLOBAL/DELETE_ACCOUNT_BACKEND_SUCCESS',
  DELETE_ACCOUNT_BACKEND_FAILURE: 'GLOBAL/DELETE_ACCOUNT_BACKEND_FAILURE',
  CLEAR_BACKEND_FORM: 'GLOBAL/CLEAR_BACKEND_FORM',

  // Scan lookup
  LOOKUP_SCAN: 'GLOBAL/LOOKUP_SCAN',
  LOOKUP_SCAN_SUCCESS: 'GLOBAL/LOOKUP_SCAN_SUCCESS',
  LOOKUP_SCAN_FAILURE: 'GLOBAL/LOOKUP_SCAN_FAILURE',
  CLEAR_SCAN_LOOKUP: 'GLOBAL/CLEAR_SCAN_LOOKUP',

  // Gateways
  FETCH_GATEWAYS: 'GLOBAL/FETCH_GATEWAYS',
  FETCH_GATEWAYS_SUCCESS: 'GLOBAL/FETCH_GATEWAYS_SUCCESS',
  FETCH_GATEWAYS_FAILURE: 'GLOBAL/FETCH_GATEWAYS_FAILURE',
  CREATE_GATEWAY: 'GLOBAL/CREATE_GATEWAY',
  CREATE_GATEWAY_SUCCESS: 'GLOBAL/CREATE_GATEWAY_SUCCESS',
  CREATE_GATEWAY_FAILURE: 'GLOBAL/CREATE_GATEWAY_FAILURE',
  UPDATE_GATEWAY: 'GLOBAL/UPDATE_GATEWAY',
  UPDATE_GATEWAY_SUCCESS: 'GLOBAL/UPDATE_GATEWAY_SUCCESS',
  UPDATE_GATEWAY_FAILURE: 'GLOBAL/UPDATE_GATEWAY_FAILURE',
  DELETE_GATEWAY: 'GLOBAL/DELETE_GATEWAY',
  DELETE_GATEWAY_SUCCESS: 'GLOBAL/DELETE_GATEWAY_SUCCESS',
  DELETE_GATEWAY_FAILURE: 'GLOBAL/DELETE_GATEWAY_FAILURE',

  // Gateway backend configs
  FETCH_GATEWAY_BACKENDS: 'GLOBAL/FETCH_GATEWAY_BACKENDS',
  FETCH_GATEWAY_BACKENDS_SUCCESS: 'GLOBAL/FETCH_GATEWAY_BACKENDS_SUCCESS',
  FETCH_GATEWAY_BACKENDS_FAILURE: 'GLOBAL/FETCH_GATEWAY_BACKENDS_FAILURE',
  CREATE_GATEWAY_BACKEND: 'GLOBAL/CREATE_GATEWAY_BACKEND',
  CREATE_GATEWAY_BACKEND_SUCCESS: 'GLOBAL/CREATE_GATEWAY_BACKEND_SUCCESS',
  CREATE_GATEWAY_BACKEND_FAILURE: 'GLOBAL/CREATE_GATEWAY_BACKEND_FAILURE',
  UPDATE_GATEWAY_BACKEND: 'GLOBAL/UPDATE_GATEWAY_BACKEND',
  UPDATE_GATEWAY_BACKEND_SUCCESS: 'GLOBAL/UPDATE_GATEWAY_BACKEND_SUCCESS',
  UPDATE_GATEWAY_BACKEND_FAILURE: 'GLOBAL/UPDATE_GATEWAY_BACKEND_FAILURE',
  DELETE_GATEWAY_BACKEND: 'GLOBAL/DELETE_GATEWAY_BACKEND',
  DELETE_GATEWAY_BACKEND_SUCCESS: 'GLOBAL/DELETE_GATEWAY_BACKEND_SUCCESS',
  DELETE_GATEWAY_BACKEND_FAILURE: 'GLOBAL/DELETE_GATEWAY_BACKEND_FAILURE',
  CLEAR_GATEWAY_BACKEND_FORM: 'GLOBAL/CLEAR_GATEWAY_BACKEND_FORM',
};

export const actions = {
  fetchDashboard: () => ({ type: types.FETCH_DASHBOARD }),
  fetchOverview: (days, accountId) => ({ type: types.FETCH_OVERVIEW, days, accountId }),
  setOverviewPeriod: (days) => ({ type: types.SET_OVERVIEW_PERIOD, days }),

  fetchAccounts: () => ({ type: types.FETCH_ACCOUNTS }),
  fetchAccountDetail: (accountId) => ({
    type: types.FETCH_ACCOUNT_DETAIL,
    accountId,
  }),
  toggleAccount: (accountId, enabled) => ({
    type: types.TOGGLE_ACCOUNT,
    accountId,
    enabled,
  }),
  togglePromptLogging: (apiKeyAccountId, enabled) => ({
    type: types.TOGGLE_PROMPT_LOGGING,
    apiKeyAccountId,
    enabled,
  }),
  updateScanConfig: (apiKeyAccountId, config) => ({
    type: types.UPDATE_SCAN_CONFIG,
    apiKeyAccountId,
    config,
  }),
  onboardAccount: (authdbAccountId) => ({
    type: types.ONBOARD_ACCOUNT,
    authdbAccountId,
  }),
  clearOnboardState: () => ({ type: types.CLEAR_ONBOARD_STATE }),
  closeAccountDetail: () => ({ type: types.CLOSE_ACCOUNT_DETAIL }),

  fetchUsers: () => ({ type: types.FETCH_USERS }),
  fetchUserDetail: (userId) => ({ type: types.FETCH_USER_DETAIL, userId }),
  closeUserDetail: () => ({ type: types.CLOSE_USER_DETAIL }),

  fetchAudit: (filters = {}) => ({ type: types.FETCH_AUDIT, filters }),

  // Backend definitions
  fetchBackendDefinitions: () => ({ type: types.FETCH_BACKEND_DEFINITIONS }),
  createBackendDefinition: (data) => ({ type: types.CREATE_BACKEND_DEFINITION, data }),
  updateBackendDefinition: (backendId, data) => ({
    type: types.UPDATE_BACKEND_DEFINITION,
    backendId,
    data,
  }),
  deleteBackendDefinition: (backendId) => ({
    type: types.DELETE_BACKEND_DEFINITION,
    backendId,
  }),

  // Account backend overrides
  fetchAccountBackends: (accountId) => ({
    type: types.FETCH_ACCOUNT_BACKENDS,
    accountId,
  }),
  createAccountBackend: (accountId, data) => ({
    type: types.CREATE_ACCOUNT_BACKEND,
    accountId,
    data,
  }),
  updateAccountBackend: (accountId, overrideId, data) => ({
    type: types.UPDATE_ACCOUNT_BACKEND,
    accountId,
    overrideId,
    data,
  }),
  deleteAccountBackend: (accountId, overrideId) => ({
    type: types.DELETE_ACCOUNT_BACKEND,
    accountId,
    overrideId,
  }),
  clearBackendForm: () => ({ type: types.CLEAR_BACKEND_FORM }),

  // Scan lookup
  lookupScan: (correlationId) => ({ type: types.LOOKUP_SCAN, correlationId }),
  clearScanLookup: () => ({ type: types.CLEAR_SCAN_LOOKUP }),

  // Gateways
  fetchGateways: () => ({ type: types.FETCH_GATEWAYS }),
  createGateway: (data) => ({ type: types.CREATE_GATEWAY, data }),
  updateGateway: (gatewayId, data) => ({ type: types.UPDATE_GATEWAY, gatewayId, data }),
  deleteGateway: (gatewayId) => ({ type: types.DELETE_GATEWAY, gatewayId }),

  // Gateway backend configs
  fetchGatewayBackends: (gatewayId) => ({
    type: types.FETCH_GATEWAY_BACKENDS,
    gatewayId,
  }),
  createGatewayBackend: (gatewayId, data) => ({
    type: types.CREATE_GATEWAY_BACKEND,
    gatewayId,
    data,
  }),
  updateGatewayBackend: (gatewayId, configId, data) => ({
    type: types.UPDATE_GATEWAY_BACKEND,
    gatewayId,
    configId,
    data,
  }),
  deleteGatewayBackend: (gatewayId, configId) => ({
    type: types.DELETE_GATEWAY_BACKEND,
    gatewayId,
    configId,
  }),
  clearGatewayBackendForm: () => ({ type: types.CLEAR_GATEWAY_BACKEND_FORM }),
};

const initialState = {
  // Dashboard
  isLoading: false,
  stats: null,
  error: null,

  // Overview (new admin dashboard)
  overview: null,
  overviewLoading: false,
  overviewError: null,
  overviewPeriod: 7,

  // Accounts
  accounts: { isLoading: false, items: [], error: null },
  accountDetail: { isLoading: false, data: null, error: null },
  onboard: { isLoading: false, error: null, lastCreated: null },

  // Users
  users: { isLoading: false, items: [], error: null },
  userDetail: { isLoading: false, data: null, error: null },

  // Audit log
  audit: { isLoading: false, items: [], error: null },

  // Backend definitions (global list)
  backendDefinitions: { isLoading: false, items: [], error: null },

  // Account backend overrides
  accountBackends: {
    isLoading: false,
    items: [],
    error: null,
    selectedAccountId: null,
  },
  backendForm: { isLoading: false, error: null, lastSaved: null },

  // Scan lookup
  scanLookup: { isLoading: false, data: null, error: null },

  // Gateways
  gateways: { isLoading: false, items: [], error: null },

  // Gateway backend configs
  gatewayBackends: {
    isLoading: false,
    items: [],
    error: null,
    selectedGatewayId: null,
  },
  gatewayBackendForm: { isLoading: false, error: null, lastSaved: null },
};

export default function globalReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_DASHBOARD:
      return { ...state, isLoading: true, error: null };
    case types.FETCH_DASHBOARD_SUCCESS:
      return { ...state, isLoading: false, stats: action.stats };
    case types.FETCH_DASHBOARD_FAILURE:
      return { ...state, isLoading: false, error: action.error };

    case types.FETCH_OVERVIEW:
      return { ...state, overviewLoading: true, overviewError: null };
    case types.FETCH_OVERVIEW_SUCCESS:
      return { ...state, overviewLoading: false, overview: action.data };
    case types.FETCH_OVERVIEW_FAILURE:
      return { ...state, overviewLoading: false, overviewError: action.error };
    case types.SET_OVERVIEW_PERIOD:
      return { ...state, overviewPeriod: action.days };

    case types.FETCH_ACCOUNTS:
      return { ...state, accounts: { ...state.accounts, isLoading: true, error: null } };
    case types.FETCH_ACCOUNTS_SUCCESS:
      return { ...state, accounts: { isLoading: false, items: action.items, error: null } };
    case types.FETCH_ACCOUNTS_FAILURE:
      return { ...state, accounts: { ...state.accounts, isLoading: false, error: action.error } };

    case types.FETCH_ACCOUNT_DETAIL:
      return { ...state, accountDetail: { isLoading: true, data: null, error: null } };
    case types.FETCH_ACCOUNT_DETAIL_SUCCESS:
      return { ...state, accountDetail: { isLoading: false, data: action.data, error: null } };
    case types.FETCH_ACCOUNT_DETAIL_FAILURE:
      return { ...state, accountDetail: { isLoading: false, data: null, error: action.error } };
    case types.CLOSE_ACCOUNT_DETAIL:
      return { ...state, accountDetail: { isLoading: false, data: null, error: null } };

    case types.TOGGLE_ACCOUNT_SUCCESS: {
      const items = state.accounts.items.map((a) =>
        a.id === action.data.id ? { ...a, ...action.data } : a
      );
      const detail =
        state.accountDetail.data?.id === action.data.id
          ? { ...state.accountDetail, data: { ...state.accountDetail.data, ...action.data } }
          : state.accountDetail;
      return { ...state, accounts: { ...state.accounts, items }, accountDetail: detail };
    }
    case types.TOGGLE_ACCOUNT_FAILURE:
      return { ...state, accounts: { ...state.accounts, error: action.error } };

    case types.TOGGLE_PROMPT_LOGGING_SUCCESS: {
      // Patch the matching api_key in accountDetail.data.api_keys[]
      const detail = state.accountDetail.data;
      if (!detail || !Array.isArray(detail.api_keys)) return state;
      const api_keys = detail.api_keys.map((k) =>
        k.id === action.data.account_id
          ? { ...k, enable_prompt_logging: action.data.enable_prompt_logging }
          : k
      );
      return {
        ...state,
        accountDetail: { ...state.accountDetail, data: { ...detail, api_keys } },
      };
    }
    case types.TOGGLE_PROMPT_LOGGING_FAILURE:
      return {
        ...state,
        accountDetail: { ...state.accountDetail, error: action.error },
      };

    case types.UPDATE_SCAN_CONFIG_SUCCESS: {
      // Update scan_config at the account (customer) level
      // API response: { account_id, token_threshold, window_overlap, quick_timeout_s, max_accumulated_mb }
      const detail = state.accountDetail.data;
      if (!detail) return state;
      const { account_id, ...scanConfigFields } = action.data;
      // Only update if this is the currently viewed account
      if (detail.id !== account_id) return state;
      return {
        ...state,
        accountDetail: {
          ...state.accountDetail,
          data: { ...detail, scan_config: scanConfigFields },
        },
      };
    }
    case types.UPDATE_SCAN_CONFIG_FAILURE:
      return {
        ...state,
        accountDetail: { ...state.accountDetail, error: action.error },
      };

    case types.ONBOARD_ACCOUNT:
      return { ...state, onboard: { isLoading: true, error: null, lastCreated: null } };
    case types.ONBOARD_ACCOUNT_SUCCESS: {
      const existing = state.accounts.items.find((a) => a.id === action.data.id);
      const items = existing
        ? state.accounts.items.map((a) => (a.id === action.data.id ? { ...a, ...action.data } : a))
        : [action.data, ...state.accounts.items];
      return {
        ...state,
        onboard: { isLoading: false, error: null, lastCreated: action.data },
        accounts: { ...state.accounts, items },
      };
    }
    case types.ONBOARD_ACCOUNT_FAILURE:
      return { ...state, onboard: { isLoading: false, error: action.error, lastCreated: null } };
    case types.CLEAR_ONBOARD_STATE:
      return { ...state, onboard: { isLoading: false, error: null, lastCreated: null } };

    case types.FETCH_USERS:
      return { ...state, users: { ...state.users, isLoading: true, error: null } };
    case types.FETCH_USERS_SUCCESS:
      return { ...state, users: { isLoading: false, items: action.items, error: null } };
    case types.FETCH_USERS_FAILURE:
      return { ...state, users: { ...state.users, isLoading: false, error: action.error } };

    case types.FETCH_USER_DETAIL:
      return { ...state, userDetail: { isLoading: true, data: null, error: null } };
    case types.FETCH_USER_DETAIL_SUCCESS:
      return { ...state, userDetail: { isLoading: false, data: action.data, error: null } };
    case types.FETCH_USER_DETAIL_FAILURE:
      return { ...state, userDetail: { isLoading: false, data: null, error: action.error } };
    case types.CLOSE_USER_DETAIL:
      return { ...state, userDetail: { isLoading: false, data: null, error: null } };

    case types.FETCH_AUDIT:
      return { ...state, audit: { ...state.audit, isLoading: true, error: null } };
    case types.FETCH_AUDIT_SUCCESS:
      return { ...state, audit: { isLoading: false, items: action.items, error: null } };
    case types.FETCH_AUDIT_FAILURE:
      return { ...state, audit: { ...state.audit, isLoading: false, error: action.error } };

    // Backend definitions
    case types.FETCH_BACKEND_DEFINITIONS:
      return { ...state, backendDefinitions: { ...state.backendDefinitions, isLoading: true, error: null } };
    case types.FETCH_BACKEND_DEFINITIONS_SUCCESS:
      return { ...state, backendDefinitions: { isLoading: false, items: action.items, error: null } };
    case types.FETCH_BACKEND_DEFINITIONS_FAILURE:
      return { ...state, backendDefinitions: { ...state.backendDefinitions, isLoading: false, error: action.error } };

    case types.CREATE_BACKEND_DEFINITION_SUCCESS:
      return {
        ...state,
        backendDefinitions: {
          ...state.backendDefinitions,
          items: [...state.backendDefinitions.items, action.data],
        },
      };
    case types.UPDATE_BACKEND_DEFINITION_SUCCESS:
      return {
        ...state,
        backendDefinitions: {
          ...state.backendDefinitions,
          items: state.backendDefinitions.items.map((b) =>
            b.id === action.data.id ? action.data : b
          ),
        },
      };
    case types.DELETE_BACKEND_DEFINITION_SUCCESS:
      return {
        ...state,
        backendDefinitions: {
          ...state.backendDefinitions,
          items: state.backendDefinitions.items.filter((b) => b.id !== action.backendId),
        },
      };

    // Account backend overrides
    case types.FETCH_ACCOUNT_BACKENDS:
      return {
        ...state,
        accountBackends: { isLoading: true, items: [], error: null, selectedAccountId: action.accountId },
      };
    case types.FETCH_ACCOUNT_BACKENDS_SUCCESS:
      return {
        ...state,
        accountBackends: { ...state.accountBackends, isLoading: false, items: action.items },
      };
    case types.FETCH_ACCOUNT_BACKENDS_FAILURE:
      return {
        ...state,
        accountBackends: { ...state.accountBackends, isLoading: false, error: action.error },
      };

    case types.CREATE_ACCOUNT_BACKEND:
      return { ...state, backendForm: { isLoading: true, error: null, lastSaved: null } };
    case types.CREATE_ACCOUNT_BACKEND_SUCCESS:
      return {
        ...state,
        backendForm: { isLoading: false, error: null, lastSaved: action.data },
        accountBackends: {
          ...state.accountBackends,
          items: [...state.accountBackends.items, action.data],
        },
      };
    case types.CREATE_ACCOUNT_BACKEND_FAILURE:
      return { ...state, backendForm: { isLoading: false, error: action.error, lastSaved: null } };

    case types.UPDATE_ACCOUNT_BACKEND:
      return { ...state, backendForm: { isLoading: true, error: null, lastSaved: null } };
    case types.UPDATE_ACCOUNT_BACKEND_SUCCESS:
      return {
        ...state,
        backendForm: { isLoading: false, error: null, lastSaved: action.data },
        accountBackends: {
          ...state.accountBackends,
          items: state.accountBackends.items.map((b) =>
            b.id === action.data.id ? action.data : b
          ),
        },
      };
    case types.UPDATE_ACCOUNT_BACKEND_FAILURE:
      return { ...state, backendForm: { isLoading: false, error: action.error, lastSaved: null } };

    case types.DELETE_ACCOUNT_BACKEND:
      return { ...state, backendForm: { isLoading: true, error: null, lastSaved: null } };
    case types.DELETE_ACCOUNT_BACKEND_SUCCESS:
      return {
        ...state,
        backendForm: { isLoading: false, error: null, lastSaved: null },
        accountBackends: {
          ...state.accountBackends,
          items: state.accountBackends.items.filter((b) => b.id !== action.overrideId),
        },
      };
    case types.DELETE_ACCOUNT_BACKEND_FAILURE:
      return { ...state, backendForm: { isLoading: false, error: action.error, lastSaved: null } };

    case types.CLEAR_BACKEND_FORM:
      return { ...state, backendForm: { isLoading: false, error: null, lastSaved: null } };

    // Scan lookup
    case types.LOOKUP_SCAN:
      return { ...state, scanLookup: { isLoading: true, data: null, error: null } };
    case types.LOOKUP_SCAN_SUCCESS:
      return { ...state, scanLookup: { isLoading: false, data: action.data, error: null } };
    case types.LOOKUP_SCAN_FAILURE:
      return { ...state, scanLookup: { isLoading: false, data: null, error: action.error } };
    case types.CLEAR_SCAN_LOOKUP:
      return { ...state, scanLookup: { isLoading: false, data: null, error: null } };

    // Gateways
    case types.FETCH_GATEWAYS:
      return { ...state, gateways: { ...state.gateways, isLoading: true, error: null } };
    case types.FETCH_GATEWAYS_SUCCESS:
      return { ...state, gateways: { isLoading: false, items: action.items, error: null } };
    case types.FETCH_GATEWAYS_FAILURE:
      return { ...state, gateways: { ...state.gateways, isLoading: false, error: action.error } };

    case types.CREATE_GATEWAY_SUCCESS:
      return {
        ...state,
        gateways: { ...state.gateways, items: [...state.gateways.items, action.data], error: null },
      };
    case types.CREATE_GATEWAY_FAILURE:
      return { ...state, gateways: { ...state.gateways, error: action.error } };

    case types.UPDATE_GATEWAY_SUCCESS:
      return {
        ...state,
        gateways: {
          ...state.gateways,
          items: state.gateways.items.map((g) => (g.id === action.data.id ? action.data : g)),
          error: null,
        },
      };
    case types.UPDATE_GATEWAY_FAILURE:
      return { ...state, gateways: { ...state.gateways, error: action.error } };

    case types.DELETE_GATEWAY_SUCCESS:
      return {
        ...state,
        gateways: {
          ...state.gateways,
          items: state.gateways.items.filter((g) => g.id !== action.gatewayId),
          error: null,
        },
      };
    case types.DELETE_GATEWAY_FAILURE:
      return { ...state, gateways: { ...state.gateways, error: action.error } };

    // Gateway backend configs
    case types.FETCH_GATEWAY_BACKENDS:
      return {
        ...state,
        gatewayBackends: { isLoading: true, items: [], error: null, selectedGatewayId: action.gatewayId },
      };
    case types.FETCH_GATEWAY_BACKENDS_SUCCESS:
      return {
        ...state,
        gatewayBackends: { ...state.gatewayBackends, isLoading: false, items: action.items },
      };
    case types.FETCH_GATEWAY_BACKENDS_FAILURE:
      return {
        ...state,
        gatewayBackends: { ...state.gatewayBackends, isLoading: false, error: action.error },
      };

    case types.CREATE_GATEWAY_BACKEND:
      return { ...state, gatewayBackendForm: { isLoading: true, error: null, lastSaved: null } };
    case types.CREATE_GATEWAY_BACKEND_SUCCESS:
      return {
        ...state,
        gatewayBackendForm: { isLoading: false, error: null, lastSaved: action.data },
        gatewayBackends: {
          ...state.gatewayBackends,
          items: [...state.gatewayBackends.items, action.data],
        },
      };
    case types.CREATE_GATEWAY_BACKEND_FAILURE:
      return { ...state, gatewayBackendForm: { isLoading: false, error: action.error, lastSaved: null } };

    case types.UPDATE_GATEWAY_BACKEND:
      return { ...state, gatewayBackendForm: { isLoading: true, error: null, lastSaved: null } };
    case types.UPDATE_GATEWAY_BACKEND_SUCCESS:
      return {
        ...state,
        gatewayBackendForm: { isLoading: false, error: null, lastSaved: action.data },
        gatewayBackends: {
          ...state.gatewayBackends,
          items: state.gatewayBackends.items.map((c) =>
            c.id === action.data.id ? action.data : c
          ),
        },
      };
    case types.UPDATE_GATEWAY_BACKEND_FAILURE:
      return { ...state, gatewayBackendForm: { isLoading: false, error: action.error, lastSaved: null } };

    case types.DELETE_GATEWAY_BACKEND:
      return { ...state, gatewayBackendForm: { isLoading: true, error: null, lastSaved: null } };
    case types.DELETE_GATEWAY_BACKEND_SUCCESS:
      return {
        ...state,
        gatewayBackendForm: { isLoading: false, error: null, lastSaved: null },
        gatewayBackends: {
          ...state.gatewayBackends,
          items: state.gatewayBackends.items.filter((c) => c.id !== action.configId),
        },
      };
    case types.DELETE_GATEWAY_BACKEND_FAILURE:
      return { ...state, gatewayBackendForm: { isLoading: false, error: action.error, lastSaved: null } };

    case types.CLEAR_GATEWAY_BACKEND_FORM:
      return { ...state, gatewayBackendForm: { isLoading: false, error: null, lastSaved: null } };

    default:
      return state;
  }
}

// -- sagas --

const errMsg = (e, fallback) =>
  e.response?.data?.error || e.response?.data?.detail || fallback;

function* fetchDashboardSaga() {
  try {
    const res = yield call(api.get, '/api/v1/support/dashboard/');
    yield put({ type: types.FETCH_DASHBOARD_SUCCESS, stats: res.data });
  } catch (e) {
    yield put({ type: types.FETCH_DASHBOARD_FAILURE, error: errMsg(e, 'Failed to load global dashboard') });
  }
}

function* fetchOverviewSaga(action) {
  try {
    const days = action.days || 7;
    const params = new URLSearchParams({ days });
    if (action.accountId) {
      params.append('account_id', action.accountId);
    }
    const res = yield call(
      api.get,
      `/api/v1/support/dashboard-overview/?${params.toString()}`
    );
    yield put({ type: types.FETCH_OVERVIEW_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.FETCH_OVERVIEW_FAILURE,
      error: errMsg(e, 'Failed to load admin overview'),
    });
  }
}

function* fetchAccountsSaga() {
  try {
    const res = yield call(api.get, '/api/v1/support/accounts/');
    yield put({ type: types.FETCH_ACCOUNTS_SUCCESS, items: res.data.results || [] });
  } catch (e) {
    yield put({ type: types.FETCH_ACCOUNTS_FAILURE, error: errMsg(e, 'Failed to load accounts') });
  }
}

function* fetchAccountDetailSaga(action) {
  try {
    const res = yield call(api.get, `/api/v1/support/accounts/${action.accountId}/`);
    yield put({ type: types.FETCH_ACCOUNT_DETAIL_SUCCESS, data: res.data });
  } catch (e) {
    yield put({ type: types.FETCH_ACCOUNT_DETAIL_FAILURE, error: errMsg(e, 'Failed to load account') });
  }
}

function* toggleAccountSaga(action) {
  try {
    const res = yield call(api.patch, `/api/v1/support/accounts/${action.accountId}/`, {
      ai_guardian_enabled: action.enabled,
    });
    yield put({ type: types.TOGGLE_ACCOUNT_SUCCESS, data: res.data });
  } catch (e) {
    yield put({ type: types.TOGGLE_ACCOUNT_FAILURE, error: errMsg(e, 'Failed to toggle account') });
  }
}

function* togglePromptLoggingSaga(action) {
  try {
    const res = yield call(
      api.post,
      `/api/v1/support/accounts/${action.apiKeyAccountId}/prompt-logging`,
      { enable_prompt_logging: action.enabled },
    );
    yield put({ type: types.TOGGLE_PROMPT_LOGGING_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.TOGGLE_PROMPT_LOGGING_FAILURE,
      error: errMsg(e, 'Failed to toggle prompt logging'),
    });
  }
}

function* updateScanConfigSaga(action) {
  try {
    const res = yield call(
      api.patch,
      `/api/v1/support/accounts/${action.apiKeyAccountId}/scan-config`,
      action.config,
    );
    yield put({ type: types.UPDATE_SCAN_CONFIG_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.UPDATE_SCAN_CONFIG_FAILURE,
      error: errMsg(e, 'Failed to update scan config'),
    });
  }
}

function* onboardAccountSaga(action) {
  try {
    const res = yield call(api.post, '/api/v1/support/accounts/onboard/', {
      authdb_account_id: action.authdbAccountId,
    });
    yield put({ type: types.ONBOARD_ACCOUNT_SUCCESS, data: res.data });
  } catch (e) {
    yield put({ type: types.ONBOARD_ACCOUNT_FAILURE, error: errMsg(e, 'Failed to onboard account') });
  }
}

function* fetchUsersSaga() {
  try {
    const res = yield call(api.get, '/api/v1/support/users/');
    yield put({ type: types.FETCH_USERS_SUCCESS, items: res.data.results || [] });
  } catch (e) {
    yield put({ type: types.FETCH_USERS_FAILURE, error: errMsg(e, 'Failed to load users') });
  }
}

function* fetchUserDetailSaga(action) {
  try {
    const res = yield call(api.get, `/api/v1/support/users/${action.userId}/`);
    yield put({ type: types.FETCH_USER_DETAIL_SUCCESS, data: res.data });
  } catch (e) {
    yield put({ type: types.FETCH_USER_DETAIL_FAILURE, error: errMsg(e, 'Failed to load user') });
  }
}

function* fetchAuditSaga(action) {
  try {
    const params = new URLSearchParams(action.filters || {}).toString();
    const res = yield call(
      api.get,
      `/api/v1/support/audit/${params ? `?${params}` : ''}`
    );
    yield put({
      type: types.FETCH_AUDIT_SUCCESS,
      items: res.data.results || [],
    });
  } catch (e) {
    yield put({
      type: types.FETCH_AUDIT_FAILURE,
      error: errMsg(e, 'Failed to load audit log'),
    });
  }
}

function* fetchBackendDefinitionsSaga() {
  try {
    const res = yield call(api.get, '/api/v1/support/backends/');
    yield put({ type: types.FETCH_BACKEND_DEFINITIONS_SUCCESS, items: res.data.results || res.data || [] });
  } catch (e) {
    yield put({
      type: types.FETCH_BACKEND_DEFINITIONS_FAILURE,
      error: errMsg(e, 'Failed to load backend definitions'),
    });
  }
}

function* createBackendDefinitionSaga(action) {
  try {
    const res = yield call(api.post, '/api/v1/support/backends/', action.data);
    yield put({ type: types.CREATE_BACKEND_DEFINITION_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.CREATE_BACKEND_DEFINITION_FAILURE,
      error: errMsg(e, 'Failed to create backend definition'),
    });
  }
}

function* updateBackendDefinitionSaga(action) {
  try {
    const res = yield call(
      api.patch,
      `/api/v1/support/backends/${action.backendId}/`,
      action.data
    );
    yield put({ type: types.UPDATE_BACKEND_DEFINITION_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.UPDATE_BACKEND_DEFINITION_FAILURE,
      error: errMsg(e, 'Failed to update backend definition'),
    });
  }
}

function* deleteBackendDefinitionSaga(action) {
  try {
    yield call(api.delete, `/api/v1/support/backends/${action.backendId}/`);
    yield put({
      type: types.DELETE_BACKEND_DEFINITION_SUCCESS,
      backendId: action.backendId,
    });
  } catch (e) {
    yield put({
      type: types.DELETE_BACKEND_DEFINITION_FAILURE,
      error: errMsg(e, 'Failed to delete backend definition'),
    });
  }
}

function* fetchAccountBackendsSaga(action) {
  try {
    const res = yield call(api.get, `/api/v1/support/accounts/${action.accountId}/backends/`);
    yield put({ type: types.FETCH_ACCOUNT_BACKENDS_SUCCESS, items: res.data.results || [] });
  } catch (e) {
    yield put({
      type: types.FETCH_ACCOUNT_BACKENDS_FAILURE,
      error: errMsg(e, 'Failed to load account backends'),
    });
  }
}

function* createAccountBackendSaga(action) {
  try {
    const res = yield call(
      api.post,
      `/api/v1/support/accounts/${action.accountId}/backends/`,
      action.data
    );
    yield put({ type: types.CREATE_ACCOUNT_BACKEND_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.CREATE_ACCOUNT_BACKEND_FAILURE,
      error: errMsg(e, 'Failed to create backend override'),
    });
  }
}

function* updateAccountBackendSaga(action) {
  try {
    const res = yield call(
      api.patch,
      `/api/v1/support/accounts/${action.accountId}/backends/${action.overrideId}/`,
      action.data
    );
    yield put({ type: types.UPDATE_ACCOUNT_BACKEND_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.UPDATE_ACCOUNT_BACKEND_FAILURE,
      error: errMsg(e, 'Failed to update backend override'),
    });
  }
}

function* deleteAccountBackendSaga(action) {
  try {
    yield call(
      api.delete,
      `/api/v1/support/accounts/${action.accountId}/backends/${action.overrideId}/`
    );
    yield put({ type: types.DELETE_ACCOUNT_BACKEND_SUCCESS, overrideId: action.overrideId });
  } catch (e) {
    yield put({
      type: types.DELETE_ACCOUNT_BACKEND_FAILURE,
      error: errMsg(e, 'Failed to delete backend override'),
    });
  }
}

function* lookupScanSaga(action) {
  try {
    const encodedId = encodeURIComponent(action.correlationId);
    const res = yield call(api.get, `/api/v1/support/scans/${encodedId}/`);
    yield put({ type: types.LOOKUP_SCAN_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.LOOKUP_SCAN_FAILURE,
      error: errMsg(e, 'Scan not found'),
    });
  }
}

function* fetchGatewaysSaga() {
  try {
    const res = yield call(api.get, '/api/v1/support/gateways/');
    yield put({ type: types.FETCH_GATEWAYS_SUCCESS, items: res.data.results || [] });
  } catch (e) {
    yield put({
      type: types.FETCH_GATEWAYS_FAILURE,
      error: errMsg(e, 'Failed to load gateways'),
    });
  }
}

function* createGatewaySaga(action) {
  try {
    const res = yield call(api.post, '/api/v1/support/gateways/', action.data);
    yield put({ type: types.CREATE_GATEWAY_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.CREATE_GATEWAY_FAILURE,
      error: errMsg(e, 'Failed to create gateway'),
    });
  }
}

function* updateGatewaySaga(action) {
  try {
    const res = yield call(
      api.patch,
      `/api/v1/support/gateways/${action.gatewayId}/`,
      action.data
    );
    yield put({ type: types.UPDATE_GATEWAY_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.UPDATE_GATEWAY_FAILURE,
      error: errMsg(e, 'Failed to update gateway'),
    });
  }
}

function* deleteGatewaySaga(action) {
  try {
    yield call(api.delete, `/api/v1/support/gateways/${action.gatewayId}/`);
    yield put({ type: types.DELETE_GATEWAY_SUCCESS, gatewayId: action.gatewayId });
  } catch (e) {
    yield put({
      type: types.DELETE_GATEWAY_FAILURE,
      error: errMsg(e, 'Failed to delete gateway'),
    });
  }
}

function* fetchGatewayBackendsSaga(action) {
  try {
    const res = yield call(api.get, `/api/v1/support/gateways/${action.gatewayId}/backends/`);
    yield put({ type: types.FETCH_GATEWAY_BACKENDS_SUCCESS, items: res.data.results || [] });
  } catch (e) {
    yield put({
      type: types.FETCH_GATEWAY_BACKENDS_FAILURE,
      error: errMsg(e, 'Failed to load gateway backends'),
    });
  }
}

function* createGatewayBackendSaga(action) {
  try {
    const res = yield call(
      api.post,
      `/api/v1/support/gateways/${action.gatewayId}/backends/`,
      action.data
    );
    yield put({ type: types.CREATE_GATEWAY_BACKEND_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.CREATE_GATEWAY_BACKEND_FAILURE,
      error: errMsg(e, 'Failed to create gateway backend config'),
    });
  }
}

function* updateGatewayBackendSaga(action) {
  try {
    const res = yield call(
      api.patch,
      `/api/v1/support/gateways/${action.gatewayId}/backends/${action.configId}/`,
      action.data
    );
    yield put({ type: types.UPDATE_GATEWAY_BACKEND_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.UPDATE_GATEWAY_BACKEND_FAILURE,
      error: errMsg(e, 'Failed to update gateway backend config'),
    });
  }
}

function* deleteGatewayBackendSaga(action) {
  try {
    yield call(
      api.delete,
      `/api/v1/support/gateways/${action.gatewayId}/backends/${action.configId}/`
    );
    yield put({ type: types.DELETE_GATEWAY_BACKEND_SUCCESS, configId: action.configId });
  } catch (e) {
    yield put({
      type: types.DELETE_GATEWAY_BACKEND_FAILURE,
      error: errMsg(e, 'Failed to delete gateway backend config'),
    });
  }
}

export function* globalSagas() {
  yield takeLatest(types.FETCH_DASHBOARD, fetchDashboardSaga);
  yield takeLatest(types.FETCH_OVERVIEW, fetchOverviewSaga);
  yield takeLatest(types.FETCH_ACCOUNTS, fetchAccountsSaga);
  yield takeLatest(types.FETCH_ACCOUNT_DETAIL, fetchAccountDetailSaga);
  yield takeLatest(types.TOGGLE_ACCOUNT, toggleAccountSaga);
  yield takeLatest(types.TOGGLE_PROMPT_LOGGING, togglePromptLoggingSaga);
  yield takeLatest(types.UPDATE_SCAN_CONFIG, updateScanConfigSaga);
  yield takeLatest(types.ONBOARD_ACCOUNT, onboardAccountSaga);
  yield takeLatest(types.FETCH_USERS, fetchUsersSaga);
  yield takeLatest(types.FETCH_USER_DETAIL, fetchUserDetailSaga);
  yield takeLatest(types.FETCH_AUDIT, fetchAuditSaga);
  yield takeLatest(types.FETCH_BACKEND_DEFINITIONS, fetchBackendDefinitionsSaga);
  yield takeLatest(types.CREATE_BACKEND_DEFINITION, createBackendDefinitionSaga);
  yield takeLatest(types.UPDATE_BACKEND_DEFINITION, updateBackendDefinitionSaga);
  yield takeLatest(types.DELETE_BACKEND_DEFINITION, deleteBackendDefinitionSaga);
  yield takeLatest(types.FETCH_ACCOUNT_BACKENDS, fetchAccountBackendsSaga);
  yield takeLatest(types.CREATE_ACCOUNT_BACKEND, createAccountBackendSaga);
  yield takeLatest(types.UPDATE_ACCOUNT_BACKEND, updateAccountBackendSaga);
  yield takeLatest(types.DELETE_ACCOUNT_BACKEND, deleteAccountBackendSaga);
  yield takeLatest(types.LOOKUP_SCAN, lookupScanSaga);
  yield takeLatest(types.FETCH_GATEWAYS, fetchGatewaysSaga);
  yield takeLatest(types.CREATE_GATEWAY, createGatewaySaga);
  yield takeLatest(types.UPDATE_GATEWAY, updateGatewaySaga);
  yield takeLatest(types.DELETE_GATEWAY, deleteGatewaySaga);
  yield takeLatest(types.FETCH_GATEWAY_BACKENDS, fetchGatewayBackendsSaga);
  yield takeLatest(types.CREATE_GATEWAY_BACKEND, createGatewayBackendSaga);
  yield takeLatest(types.UPDATE_GATEWAY_BACKEND, updateGatewayBackendSaga);
  yield takeLatest(types.DELETE_GATEWAY_BACKEND, deleteGatewayBackendSaga);
}
